<template>
  <div :class="$style.testError">
    <span
      :class="{[$style.strong]: strong}"
    >
      {{ errorMessage }}
    </span>
    <a
      v-if="showReadMore"
      :class="$style.link"
      href="javascript: void(0);"
      @click.prevent="handleReadMore"
    >Read more</a>
  </div>
</template>

<script>
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import ScimTestError from 'client/applications/scim/ScimTestError';
import ScimTestErrorModal from 'client/components/Modal/ScimTestErrorModal.vue';

export default {
  name: 'ScimTestError',

  maxTextLength: 200,

  props: {
    errorObject: {
      type: ScimTestError,
      default: new ScimTestError(),
    },
    strong: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    errorMessage() {
      let text = this.errorObject.format();
      const { maxTextLength } = this.$options;
      if (text.length > maxTextLength) {
        text = text.substr(0, maxTextLength);
        text += '...';
      }
      return text;
    },

    showReadMore() {
      const { maxTextLength } = this.$options;
      return this.errorObject.format().length > maxTextLength;
    },
  },

  methods: {
    handleReadMore() {
      ModalEventBus.open({
        component: ScimTestErrorModal,
        componentProps: {
          error: this.errorObject.formatErrorType(),
          errorText: this.errorObject.message,
        },
      });
    },
  },
};
</script>

<style module>
  @import './css/IdentityManagementCommon.css';

  .strong {
    font-weight: bold;
  }

  .testError {
    display: inline;
  }
</style>
